<template>
	<div class="dialog-form">
		<div class="dialog-form-body">
			<el-form ref="form" :model="detail" label-width="100px">
				<el-form-item :required="true" label="所属平台">
					<el-radio-group v-model="detail.type" @change="handlerChange">
						<el-radio :label="1">多多账号</el-radio>
						<el-radio :label="2">巴巴账号</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item :required="true" label="自动采购" v-if="detail.type==2">
					<el-radio-group v-model="detail.alibaba_auto_purchase" @change="handlerAlibabaAutoPurchase">
						<el-radio :label="0">关闭</el-radio>
						<el-radio :label="1">开启</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item :required="true" label="手机号">
					<el-input v-model="detail.phone" placeholder="请输入手机号"></el-input>
				</el-form-item>
				<el-form-item label="名称">
					<el-input v-model="detail.name" placeholder="请输入名称"></el-input>
				</el-form-item>
				<el-form-item label="支付宝账号" v-if="detail.type === 1">
					<el-input v-model="detail.alipay_account" placeholder="请输入支付宝账号"></el-input>
				</el-form-item>
				<el-form-item label="支付宝密码" v-if="detail.type === 1">
					<el-input v-model="detail.alipay_password" placeholder="请输入支付宝密码"></el-input>
				</el-form-item>
<!--				<el-form-item label="开启免密支付" v-if="detail.type === 2">-->
<!--					<el-switch-->
<!--						v-model="detail.is_without_code_pay"-->
<!--						active-color="#13ce66"-->
<!--						inactive-color="#DDDDDD"-->
<!--						@change="handlerSwitchChange"-->
<!--					>-->
<!--					</el-switch>-->
<!--				</el-form-item>-->
				<el-form-item label="利润差">
					<el-input-number v-model="detail.profit_margin" placeholder="请输入"></el-input-number>
					<p class="red"><i class="iconfont el-icon-warning"></i> 利润低于N元不采购</p>
				</el-form-item>
			</el-form>
		</div>
		<div class="dialog-form-footer">
			<el-button class="default" @click="handlerCancel">取消</el-button>
			<el-button class="primary" @click="handlerSubmit">确定</el-button>
		</div>
	</div>
</template>

<script>
import {mapActions} from "vuex";

const DEFAULT_PAYLOAD = {
	type: null,
	phone: null,
	name: null,
	alibaba_auto_purchase: null,
	alipay_account: null,
	alipay_password: null,
	profit_margin: null,
	is_without_code_pay: null
}

export default {
	props:{
		detail:{
			type:Object,
			default(){
				return DEFAULT_PAYLOAD
			}
		}
	},
	data(){
		return {}
	},
	methods:{
		...mapActions({
			opPddAccountList: "ucenter/opPddAccountList",
			opCheckIsOpenProtocolPay: "ucenter/opCheckIsOpenProtocolPay",
		}),
		handlerSubmit(){
			const data = this.detail;
			this.$emit('confirm', data)
		},
		handlerCancel(){
			this.$emit('cancel')
		},
		handlerChange(val){
			if(val === 1){
				this.detail.profit_margin = 0.5
			}else{
				this.detail.profit_margin = 0.3
			}
		},
		handlerAlibabaAutoPurchase(val){
			if(val === 1){
				this.detail.alibaba_auto_purchase = 1
			}else{
				this.detail.alibaba_auto_purchase = 0
			}
		},
		handlerSwitchChange(val) {
			console.log(val)
			if (val) {
				if (!this.detail.id) {
					this.$message.error('请先创建账号，再来启用免密支付');
					this.detail.is_without_code_pay = false;
					return false;
				}
				this.opCheckIsOpenProtocolPay({
					data: {
						id: this.detail.id
					},
					success: (res) => {
						console.log(res);
						if (res.code !== 200) {
							this.detail.is_without_code_pay = false;
							this.$message.error(res.msg);
						}else{
							if (res.data.signedStatus && res.data.bindingStatus) {
								this.$message.success('该账号已开通免密支付');
							}else{
								this.detail.is_without_code_pay = false;
								this.$message.error('该账号未开通免密支付', {duration: 2000});
								setTimeout(() => {
									window.open(res.data.signUrl);
								}, 2000);
								
							}
						}
					}
				})
				
			}
		},
	}
}
</script>

<style lang="less" scoped>
.dialog-form{
	&-body{
		.el-form{
			:deep(&-item){
				&__label{
					font-size: 14px;
					color: #666666;
				}
			}
			.el-select{
				width: 290px;
			}
			.el-input{
				width: 290px;
			}
		}
		&-tips{
			margin-top: 40px;
			font-size: 12px;
			line-height: 24px;
			color: #f0413e;
		}
	}
	&-footer{
		margin-top: 20px;
		display: flex;
		justify-content: flex-end;
		.el-button{
			width: 90px;
			height: 35px;
			padding: 0;
			border-radius: 6px;
			display: flex;
			align-items: center;
			justify-content: center;
			border: solid 1px #dddddd;
			color: #333333;
			font-size: 12px;
			&.default{
				background-color: #ffffff;
			}
			&.primary{
				color: #fff;
				background-color: #f0413e;
				border-color: #f0413e;
			}
		}
	}
}
</style>